import React, {Fragment, useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import {useDispatch, useSelector} from "react-redux";

import Loader from "../../components/Loader/Loader";
import savingDefaultsLottie from '../../assets/images/saving_defaults_lottie.json';

import classnames from "classnames";
import {
  getQuotaThreshold,
  getServices as onGetServices,
  getAllAWSAccounts,
  getQuotaMasterResources,
  deployMasterResourceQuotaAlerts,
  updateQuotMasterResourceConfig,
  getAllDeployedServiceQuotaAlerts,
} from "../../store/actions";
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Col,
  Modal,
  Row,
  Table,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  UncontrolledAccordion,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ModalBody,
  CardBody,
} from "reactstrap";
import {Link} from "react-router-dom";
import {
  getStateSpecificAWSLogo as getAWSLogo,
  getStateSpecificAWSLogo
} from "../../helpers/component_helpers";
import Select from "react-select";
import Multiselect from "multiselect-react-dropdown";

const ServiceQuota = props => {
  const dispatch = useDispatch();
  const [quotaThresholdBreakdown, setQuotaThresholdBreakdown] = useState({});
  const [quotaThresholdKeys, setQuotaThresholdKeys] = useState([]);
  const [subscribemodalServiceQuotaModal, setSubscribemodalServiceQuotaModal] = useState(false);
  const [changedValuesServiceQuota, setchangedValuesServiceQuota] = useState({});
  const [modalChangedValuesServiceQuota, setModalChangedValuesServiceQuota] = useState({});
  const [modalChangedKeyServiceQuota, setModalChangedKeyServiceQuota] = useState();
  const [showDeployAlertModal, setShowDeployAlertModal] = useState(false);
  const [deployButton, setDeployButton] = useState(false);
  const [mapButton, setMapButton] = useState(false);
  const [checkBox, setCheckBox] = useState({});
  const [allCheckBox, setAllCheckBox] = useState(false);
  const [serviceName, setServiceName] = useState({})
  const [serviceOptions, setServiceOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const aws_accounts = useSelector(state => state.Onboarding.aws_accounts || []);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const handleCheckBox = (key) => {
    setDeployButton(false);
    let checkBoxObj = {};
    Object.assign(checkBoxObj, checkBox);
    if (checkBoxObj[key] === true) {
      delete checkBoxObj[key];
    } else {
      checkBoxObj[key] = true
    }
    if (Object.keys(checkBoxObj).length > 0) {
      setMapButton(true);
    } else {
      setMapButton(false);
    }
    // checkDeploy(checkBoxObj);
    setCheckBox(checkBoxObj);
    // setAllCheckBox(false);
  };
  //

  const [allAwsAccounts, setAllAwsAccounts] = useState(aws_accounts);
  const reduxServices = useSelector(state =>
    state.Service.services
  );
  useEffect(() => {
    dispatch(getAllAWSAccounts());
  }, [getAllAWSAccounts]);

  useEffect(() => {
    setAllAwsAccounts(aws_accounts);
  }, [aws_accounts.length]);


  const {service_quota_thresholds} = useSelector(state => ({
    service_quota_thresholds: state.Threshold.service_quota_threshold || {}
  }));

  const {quota_master_resources} = useSelector(state => ({
    quota_master_resources: state.Threshold.quota_master_resources || []
  }));

  const {deployed_service_quota_alerts} = useSelector(state => ({
    deployed_service_quota_alerts: state.Threshold.deployed_service_quota_alerts || []
  }))

  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    dispatch(getQuotaThreshold());
    dispatch(getQuotaMasterResources());
    dispatch(onGetServices())
    dispatch(getAllDeployedServiceQuotaAlerts())
  }, [getQuotaThreshold, getQuotaMasterResources, onGetServices, getAllDeployedServiceQuotaAlerts]);

  useEffect(() => {
    if (allAwsAccounts.length > 0) {
      const regionOptions = Array.from(
        new Set(allAwsAccounts.flatMap((account) => account.aws_regions))
      ).map(region => ({value: region, label: region}));
      setRegionOptions(regionOptions);
      let accountOptions = allAwsAccounts.map((account) => ({
        value: account.id,
        label: account.account_name
      }));
      setAccountOptions(accountOptions);
    }
  }, [allAwsAccounts.length]);

  useEffect(() => {
    setQuotaThresholdBreakdown(service_quota_thresholds)
    setQuotaThresholdKeys(Object.keys(service_quota_thresholds))
  }, [service_quota_thresholds])

  const handleIndividualDeploy = () => {
    setShowDeployAlertModal(true);
  }

  const handAllCheckBox = () => {
    setDeployButton(false);
    let checkBoxObj = {}
    if (allCheckBox === true) {
      Object.keys(service_quota_thresholds).map((key, index) => {
        delete checkBoxObj[key];
      })
      setCheckBox({});
      setAllCheckBox(false);
      setMapButton(false);
    } else {
      Object.keys(service_quota_thresholds).map((key, index) => {
        checkBoxObj[key] = true
      })
      setCheckBox(checkBoxObj);
      setAllCheckBox(true);
      setMapButton(true);
    }
    // checkDeploy(checkBoxObj);
  };
  useEffect(() => {
    if (reduxServices) {
      let serviceOptions = reduxServices.map((service) => {
        return {
          value: service.id,
          label: service.name
        }
      });
      setServiceOptions(serviceOptions);
    }
  }, [reduxServices.length]);

  const handleFormChangeServiceQuota = (accordionIndex, index, event, threshold_title) => {
    const { name, value } = event.target;
    const quotaDetails = quotaThresholdBreakdown[threshold_title][index];
    const globalId = quotaDetails.id;
    const resource_name = quotaDetails.resource_name;

    setchangedValuesServiceQuota(prevState => ({
      ...prevState,
      [threshold_title]: {
        ...(prevState[threshold_title] || {}),
        [globalId]: {
          ...(prevState[threshold_title]?.[globalId] || {}),
          threshold_title,
          resource_name: resource_name,
          [name]: value
        }
      }
    }));
    quotaDetails[name] = value;
  };



  const handleSubmitServiceQuotaAlerts = (key) => {
    setSubscribemodalServiceQuotaModal(false);
    const changed_values = { ...changedValuesServiceQuota };
    const values = changed_values[key];
    Object.entries(values).forEach(([globalId, data]) => {
      let payload = {
        global_quota_threshold_id: globalId,
        application_service_id: serviceName.value,
        regions: selectedRegions.map(region => region.value),
        monitoring_system_ids: selectedAccounts.map(account => account.value),
        ...data
      };
      dispatch(updateQuotMasterResourceConfig(payload));
    });
    delete changedValuesServiceQuota[key];
    setchangedValuesServiceQuota(changedValuesServiceQuota);
  };



  const serviceQuotaHeaders = ['Metric Name', 'Comparison', 'Value', 'Label', 'Period', 'Eval Period']
  const deployedAlertsHeaders = ['Resource Name', 'Comparison', 'Value', 'Period', 'Eval Period', 'Service', 'Account Name']

  const ThresholdCondition = ['GreaterThanOrEqualToThreshold', 'GreaterThanThreshold', 'LessThanThreshold', 'LessThanOrEqualToThreshold']

  const startLoading = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
  };

  function handleSaveServiceQuotaThreshold(threshold_title) {
    setModalChangedValuesServiceQuota(changedValuesServiceQuota[threshold_title])
    setModalChangedKeyServiceQuota(threshold_title)
    setSubscribemodalServiceQuotaModal(true);
  }

  const handleDefaultDeploy = () => {
    setShowDeployAlertModal(true);
  }

  let handleServiceFormChange = (event) => {
    if (event !== null) {
      if (event['__isNew__'] === true) {
        setServiceName({
          'name': 'application_service_name',
          'value': event.value
        });
      } else {
        setServiceName({
          'name': 'application_service_id',
          'value': event.value
        });
      }
    }
  }
  const [btnHover, setBtnHover] = useState(false);
  const customStyles = {
    zIndex: 9999,
    control: (provided, state) => ({
      ...provided,
      background: '#382b42', // Background color of the control (react-select)
      borderRadius: 0,
      color: "white",
      zIndex: 100,
      position: "relative",
      borderColor: state.isFocused ? 'rgb(white, 1)' : 'rgb(white, 0.7)', // Border color when focused
    }),
    option: (provided, state) => ({
      ...provided,
      position: "relative",
      zIndex: 100,
      backgroundColor: state.isSelected ? '#292036' : state.isFocused ? '#2d2941' : '#382b42',// Background color of dropdown options
      color: state.isSelected ? '#ffffff' : '#ffffff', // Text color of dropdown options
    }),
    menu: (provided) => ({
      ...provided,
      background: '#382b42',
      position: "absolute",
      zIndex: 200, // Background color of the dropdown menu

    }),
    singleValue: (provided) => ({
      ...provided,
      position: "relative",
      color: '#ffffff', // Color of the selected value
      zIndex: 100,
    }),
  };
  const customOptionRenderer = (option) => {
    if (option.value === "/add-service") {
      return (
        <div
          className="d-flex justify-content-center align-items-center gap-2 btn btn-soft-primary"
          onMouseEnter={() => setBtnHover(true)}
          onMouseLeave={() => setBtnHover(false)}
          style={{cursor: "pointer"}}>
          <i className={`fas fa-plus font-size-14 ${btnHover ? 'text-white' : 'text-primary'}`}/>
          <span>
                {option.label}
              </span>

        </div>
      );
    } else {
      return option.label;
    }
  };

  const handleServiceMapping = () => {
    const selectedResources = Object.keys(checkBox).filter(key => checkBox[key]);
    const resourceIds = quota_master_resources
      .filter(master => selectedResources.includes(master.name))
      .map(resource => resource.id);

    const payload = {
      application_service_id: serviceName.value,
      regions: selectedRegions.map(region => region.value),
      monitoring_system_ids: selectedAccounts.map(account => account.value)
    };
    resourceIds.forEach(id => {
      dispatch(deployMasterResourceQuotaAlerts({ ...payload, quota_master_resource_id: id }));
    });
    setShowDeployAlertModal(false);
    setCheckBox({});
  };
  const serviceRef = useRef();
  const accountRef = useRef();
  const regionReff = useRef();
  const clearServiceFilter = () => {
    serviceRef.current.resetSelectedValues();
  }
  const cancelMapServiceModal = () => {
    setShowDeployAlertModal(false);
  }
  const selectRegions = (selectedList, selectedItem) => {
    setSelectedRegions(selectedList);
  }
  const removeRegions = (selectedList, removedItem) => {
    setSelectedRegions(selectedList);
  }

  const selectAccounts = (selectedList, selectedItem) => {
    setSelectedAccounts(selectedList);
  }

  const removeAccounts = (selectedList, removedItem) => {
    setSelectedAccounts(selectedList);
  }
  const [activeTab, setactiveTab] = useState("1");
  const toggleTab = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const [validationErrors, setValidationErrors] = useState({});

  // function isPeriodValid(threshold_title) {
  //   const values = changedValuesServiceQuota[threshold_title];
  //
  //   if (!values || typeof values !== 'object') {
  //     return true;
  //   }
  //
  //   if (!Array.isArray(values)) {
  //     const uuid = Object.keys(values)[0];
  //     if (!values[uuid] || values[uuid].period === undefined) {
  //       return true;
  //     }
  //
  //     const period = Number(values[uuid].period) || 0;
  //     return period > 0 && (period === 10 || period === 20 || period === 30 || period % 60 === 0);
  //   }
  //
  //   return true;
  // }
  function isPeriodValid(threshold_title) {
    const values = changedValuesServiceQuota[threshold_title];

    if (!values || typeof values !== 'object') {
      return true; // Enable button if no values
    }

    if (!Array.isArray(values)) {
      const uuid = Object.keys(values)[0];

      if (!values[uuid] || values[uuid].period === undefined) {
        return true; // No period → Button should be enabled
      }

      const period = Number(values[uuid].period) || 0;
      return period > 0 && (period === 10 || period === 20 || period === 30 || period % 60 === 0);
    }

    return true;
  }

  useEffect(() => {
    const newErrors = {};

    Object.keys(changedValuesServiceQuota).forEach(threshold_title => {
      const values = changedValuesServiceQuota[threshold_title];

      if (values && typeof values === 'object') {
        const uuid = Object.keys(values)[0];

        if (values[uuid] && values[uuid].period !== undefined) {
          const period = Number(values[uuid].period) || 0;
          if (!(period > 0 && (period === 10 || period === 20 || period === 30 || period % 60 === 0))) {
            newErrors[threshold_title] = `Period should be 10, 20, 30, or a multiple of 60.`;
          }
        }
      }
    });

    setValidationErrors(newErrors);
  }, [changedValuesServiceQuota]);


  return (
    <React.Fragment>
      <Row>
        <Col lg="8">
          <Breadcrumbs
            title={"Service Quotas"}
            breadcrumbItem={"Service Quotas"}
          />
        </Col>
      </Row>
      <Nav pills className="nav-custom">
      <NavItem className="nav-item-custom">
        <NavLink
          className={classnames({
            active: activeTab === "1",
          })}
          onClick={() => {
            toggleTab("1");
          }}
        >
          <span className="d-sm-block">Service Quota Templates</span>
        </NavLink>
      </NavItem>
        <NavItem className="nav-item-custom">
        <NavLink
          className={classnames({
            active: activeTab === "2",
          })}
          onClick={() => {
            toggleTab("2");
          }}
        >
          <span className="d-sm-block">Deployed Quota Alerts</span>
        </NavLink>
      </NavItem>
      </Nav>
      <div>
        <hr style={{border: "1px solid #556ee6", backgroundColor: "#556ee6", width: "100%", marginTop: "-1px",}}/>
        <TabContent activeTab={activeTab} className="py-4">
          <TabPane tabId="1">
            <div>
              <Row>
                <Col md={10}>
                </Col>
                <Col md={2}>
                  <div
                    style={{marginLeft: '20%'}}
                    className="d-flex align-items-center mb-3">
                    <div className="flex-shrink-0">
                      <UncontrolledDropdown className="dropdown d-inline-block me-1">
                        <DropdownToggle type="menu" className="btn btn-success" id="dropdownMenuButton1">
                          Bulk Actions
                          <i className="mdi mdi-dots-vertical"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                          <li>
                            <DropdownItem href="#" onClick={() => handAllCheckBox()}>
                              Select All
                            </DropdownItem>
                          </li>
                          <li>
                            <DropdownItem
                              href="#"
                              disabled={Object.keys(checkBox).length === 0}
                              onClick={() => handleDefaultDeploy()}
                            >
                              Deploy Alerts
                            </DropdownItem>
                          </li>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </div>
                </Col>
                <Col lg={12}>
                  <UncontrolledAccordion defaultOpen={"1"}>
                    {
                      Object.entries(quotaThresholdBreakdown).map(([key, value], index) => {
                        if (value.length > 0) {
                          return (
                            <Fragment key={index}>
                              <AccordionItem>
                                <AccordionHeader targetId={(index + 1).toString()}>
                                  <Row className="full-width">
                                    <Col md="1" className="padding-t-15">
                                      <div className="mb-2 text-center">
                                        {checkBox[key] === true ? (
                                          <i
                                            className="bx bx-check-square bx-sm"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleCheckBox(key)
                                            }}
                                          ></i>
                                        ) : (
                                          <i
                                            className="bx bx-square bx-sm"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleCheckBox(key)
                                            }}
                                          ></i>
                                        )}
                                      </div>
                                    </Col>
                                    <Col lg="6">
                                      <h5 className="change-table-text">
                                        <img src={getStateSpecificAWSLogo(key)} className="resource-logo"></img>
                                        <span className="text-primary">{key}</span>
                                      </h5>
                                    </Col>
                                    <Col lg="5" style={{
                                      position: "relative",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-end"
                                    }}>
                                      {(changedValuesServiceQuota[key] && Object.keys(changedValuesServiceQuota[key]).length > 0) ? (
                                        <>

                                          <button
                                            type="button"
                                            className="btn btn-primary"
                                            disabled={!(isPeriodValid(key))}
                                            onClick={() => handleSaveServiceQuotaThreshold(key)}
                                          >
                                            Save and Deploy
                                          </button>
                                        </>
                                      ) : null}
                                      {(checkBox[key] && checkBox[key]===true) ? (
                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                          onClick={() => handleDefaultDeploy()}
                                        >
                                          Map And Deploy
                                        </button>
                                      ) : null}
                                    </Col>
                                  </Row>
                                </AccordionHeader>
                                <AccordionBody accordionId={(index + 1).toString()}>
                                  <div className="table-responsive react-table">
                                    <Table bordered hover className="table-purple">
                                      <thead className="table-light table-nowrap"
                                             style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                      <tr>
                                        {serviceQuotaHeaders.map((header, index2) => (
                                          <th key={index2}>
                                            <div className="mb-2">
                                              {header}
                                            </div>
                                            {header === 'Period' && validationErrors[key] && (
                                              <div className="text-danger ms-2 font-size-12">
                                                {validationErrors[key]}
                                              </div>
                                            )}
                                          </th>
                                        ))}
                                      </tr>
                                      </thead>
                                      <tbody style={{textAlign: 'center', verticalAlign: 'middle'}}>
                                      {
                                        value.map((alert, index4) => {

                                          return (
                                            <Fragment key={index4}>
                                              <tr>
                                                <td>
                                                  <div
                                                    className="d-inline-flex align-items-center">
                                                    <div>{alert.resource_name}</div>
                                                  </div>
                                                </td>
                                                <td>
                                                  <div className="table-purple">
                                                    <select
                                                      id="formrow-InputState"
                                                      name="threshold_condition"
                                                      className="custom_select"
                                                      value={alert.threshold_condition}
                                                      onChange={event => handleFormChangeServiceQuota(index, index4, event, key, 'threshold_condition')}
                                                    >
                                                      {ThresholdCondition.map((item, key1) => (
                                                        <option key={key1}
                                                                value={item}>{item}</option>))}
                                                    </select>
                                                  </div>
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    value={alert.threshold_value}
                                                    name="threshold_value"
                                                    className="input"
                                                    id="autoSizingInputGroup"
                                                    placeholder="Threshold Value"
                                                    onChange={event => handleFormChangeServiceQuota(index, index4, event, key, 'threshold_value')}
                                                  />
                                                </td>
                                                <td>
                                                  {alert.threshold_unit}
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    value={alert.period}
                                                    name="period"
                                                    className="input"
                                                    id="autoSizingInputGroup"
                                                    placeholder="Period"
                                                    onChange={event => handleFormChangeServiceQuota(index, index4, event, key, 'period')}
                                                  />
                                                </td>
                                                <td>
                                                  <input
                                                    type="number"
                                                    value={alert.evaluation_periods}
                                                    name="evaluation_periods"
                                                    className="input"
                                                    id="autoSizingInputGroup"
                                                    placeholder="Eval Period"
                                                    onChange={event => handleFormChangeServiceQuota(index, index4, event, key, 'evaluation_periods')}
                                                  />
                                                </td>
                                              </tr>
                                            </Fragment>
                                          )

                                        })
                                      }
                                      </tbody>
                                    </Table>
                                  </div>
                                </AccordionBody>

                              </AccordionItem>

                            </Fragment>
                          )
                        }
                      })
                    }
                  </UncontrolledAccordion>
                </Col>
              </Row>

            </div>
          </TabPane>
          <TabPane tabId="2">
            <div>
              <div className="table-responsive react-table">
                <Table bordered hover className="table-purple">
                  <thead className="table-light table-nowrap"
                         style={{textAlign: 'center', verticalAlign: 'middle'}}>
                  <tr>
                    {deployedAlertsHeaders.map((header, index2) => (
                      <th key={index2}>
                        <div className="mb-2">
                          {header}
                        </div>
                      </th>
                    ))}
                  </tr>
                  </thead>

                  <tbody style={{textAlign: 'center', verticalAlign: 'middle'}}>
                  {
                    deployed_service_quota_alerts.map((alert, index4) => {

                      return (
                        <Fragment key={index4}>
                          <tr>
                            <td>
                              <div
                                className="d-inline-flex align-items-center">
                                <div>{alert.global_quota_threshold.resource_name}</div>
                              </div>
                            </td>
                            <td>
                              {alert.threshold_condition}
                              {/*<div className="table-purple">*/}
                              {/*  <select*/}
                              {/*    id="formrow-InputState"*/}
                              {/*    name="threshold_condition"*/}
                              {/*    className="custom_select"*/}
                              {/*    disabled={true}*/}
                              {/*    value={alert.threshold_condition}*/}
                              {/*    onChange={event => handleFormChangeServiceQuota(index, index4, event, key, 'threshold_condition')}*/}
                              {/*  >*/}
                              {/*    {ThresholdCondition.map((item, key1) => (*/}
                              {/*      <option key={key1}*/}
                              {/*              value={item}>{item}</option>))}*/}
                              {/*  </select>*/}
                              {/*</div>*/}
                            </td>
                            <td>
                              {alert.threshold_value}
                              {/*<input*/}
                              {/*  type="number"*/}
                              {/*  value=*/}
                              {/*  name="threshold_value"*/}
                              {/*  className="input"*/}
                              {/*  disabled={true}*/}
                              {/*  id="autoSizingInputGroup"*/}
                              {/*  placeholder="Deviation Count"*/}
                              {/*  onChange={event => handleFormChangeServiceQuota(index, index4, event, key, 'threshold_value')}*/}
                              {/*/>*/}
                            </td>
                            <td>
                              {alert.period}
                              {/*<input*/}
                              {/*  type="number"*/}
                              {/*  value={alert.period}*/}
                              {/*  name="period"*/}
                              {/*  className="input"*/}
                              {/*  disabled={true}*/}
                              {/*  id="autoSizingInputGroup"*/}
                              {/*  placeholder="Period"*/}
                              {/*  onChange={event => handleFormChangeServiceQuota(index, index4, event, key, 'period')}*/}
                              {/*/>*/}
                            </td>
                            <td>
                              {alert.evaluation_periods}
                              {/*<input*/}
                              {/*  type="number"*/}
                              {/*  value={alert.evaluation_periods}*/}
                              {/*  name="evaluation_periods"*/}
                              {/*  className="input"*/}
                              {/*  disabled={true}*/}
                              {/*  id="autoSizingInputGroup"*/}
                              {/*  placeholder="Eval Period"*/}
                              {/*  onChange={event => handleFormChangeServiceQuota(index, index4, event, key, 'evaluation_periods')}*/}
                              {/*/>*/}
                            </td>
                            <td>
                              <Link to={`/service/${alert.application_service_id}`}>{alert.application_service.name}</Link>
                            </td>
                            <td>
                              {alert.account_name}
                            </td>
                          </tr>
                        </Fragment>
                      )

                    })
                  }
                  </tbody>
                </Table>
              </div>
            </div>
          </TabPane>
        </TabContent>
      </div>

      <Loader
        isOpen={isLoading}
        lottieJson={savingDefaultsLottie}
        messageHeader="Saving Thresholds"
        message="Please wait while your default thresholds are being updated."
      />
      <Modal
        isOpen={subscribemodalServiceQuotaModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        size="xl"
        tabIndex="-1"
      >
        <div className="modal-header border-bottom-1 text-center">
          <h4 className="text-primary">Your are about to change the defaults for {modalChangedKeyServiceQuota} Service
            Quota Alerts!</h4>
          <button type="button" className="btn-close"
                  onClick={() => {
                    setSubscribemodalServiceQuotaModal(!subscribemodalServiceQuotaModal);
                  }} aria-label="Close">
          </button>
        </div>
        <div className="modal-body">
          <div className="text-center mb-4">
            <div className="row justify-content-center">
              <div className="col-xl-10">
                <Row>
                  <div className={'d-flex flex-row w-100'}>
                    <div className={'mb-2 ms-2'}
                         style={{width: '33.33%'}}>
                      <Select
                        options={[
                          ...serviceOptions,
                          {value: "/add-service", label: "Add new service"}
                        ]}
                        placeholder="Select an Application Service"
                        onChange={(selectedOption) => {
                          if (selectedOption && selectedOption.value === "/add-service") {
                            window.location.href = "/add-service";
                          } else {
                            handleServiceFormChange(selectedOption);
                          }
                        }}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            neutral0: '#222736',
                            neutral5: '#485EC4',
                            neutral10: '#485EC4',
                            neutral60: '#ffffff',
                            neutral70: '#ffffff',
                            neutral80: '#ffffff',
                            neutral90: '#ffffff',
                            primary: '#485EC4',
                          },
                        })}
                        styles={customStyles}
                        getOptionLabel={(option) => customOptionRenderer(option)}
                      />
                    </div>
                    <div className={'mb-2 ms-2'}
                         style={{width: '33.33%'}}>
                      <Multiselect
                        name="service_option"
                        placeholder="Select Regions"
                        ref={regionReff}
                        options={regionOptions}
                        displayValue="label"
                        closeOnSelect={true}
                        onSelect={selectRegions}
                        onRemove={removeRegions}
                        style={{
                          chips: {
                            fontSize: '10px'
                          },
                          optionContainer: {backgroundColor: "#382b42"}
                        }}/>
                    </div>
                    <div className={'mb-2 ms-2'}
                         style={{width: '33.33%'}}>
                      <Multiselect
                        name="service_option"
                        placeholder="Select Accounts"
                        ref={accountRef}
                        options={accountOptions}
                        displayValue="label"
                        closeOnSelect={true}
                        onSelect={selectAccounts}
                        onRemove={removeAccounts}
                        style={{
                          chips: {
                            fontSize: '10px'
                          },
                          optionContainer: {backgroundColor: "#382b42"}
                        }}/>

                    </div>
                  </div>
                </Row>
                <Row>
                  <Table bordered hover className="table-purple">
                    <thead className="table-light table-nowrap">
                    <tr>
                      <th>Threshold Title</th>
                      <th>Resource Name</th>
                      <th>Parameter</th>
                      <th>New Value</th>
                    </tr>
                    </thead>

                    <tbody>
                    {Object.entries(changedValuesServiceQuota).flatMap(([threshold_title, globalIds], index) =>
                      Object.entries(globalIds).flatMap(([globalId, changedValues], subIndex) =>
                        Object.entries(changedValues).map(([param, value], paramIndex) => {
                          if (param === "threshold_title" || param === "resource_name") {
                            return null;
                          }
                          return (
                            <tr key={`${index}-${subIndex}-${paramIndex}`}>
                              <td>{threshold_title}</td>
                              <td>{changedValues.resource_name}</td>
                              <td>{param}</td>
                              <td><b>{value}</b></td>
                            </tr>
                          );
                        })
                      )
                    )}
                    </tbody>
                  </Table>
                </Row>
                <button className="btn btn-primary w-md mt-3"
                        type={'submit'}
                        id="button-addon2"
                        disabled={
                          !serviceName?.value ||
                          selectedRegions.length === 0 ||
                          selectedAccounts.length === 0
                        }
                        onClick={() => {
                          handleSubmitServiceQuotaAlerts(modalChangedKeyServiceQuota);
                        }}>
                  Save Alerts
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={showDeployAlertModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        size="xl"
        tabIndex="-1">
        <ModalBody>
          <Row>
            <Col lg="6">
              <Row>
                {Object.keys(checkBox).map((key, index) => {
                  if (checkBox[key] === true) {
                    return (
                      <Col md="6" key={key}>
                        <div className="border border-white bg-transparent text-white px-2 my-1">
                          <CardBody className="p-0">
                            <div className="resource-logo-display mt-1">
                              {
                                <img src={getAWSLogo(key)} className="resource-logo" alt="Resource Logo" />
                              }
                              <h6 className="pt-2 resource-name-truncate">
                                {key}
                              </h6>
                            </div>
                          </CardBody>
                          <span className="close me-2" onClick={() => handleCheckBox(key)}></span>
                        </div>
                      </Col>
                    );
                  }
                })}
              </Row>
            </Col>
            <Col lg="6">
              <div className={'d-flex flex-column'}>
                <div className={'mb-2'}>
                  <Select
                    options={[
                      ...serviceOptions,
                      {value: "/add-service", label: "Add new service"}
                    ]}
                    placeholder="Select an Application Service"
                    onChange={(selectedOption) => {
                      if (selectedOption && selectedOption.value === "/add-service") {
                        window.location.href = "/add-service";
                      } else {
                        handleServiceFormChange(selectedOption);
                      }
                    }}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        neutral0: '#222736',
                        neutral5: '#485EC4',
                        neutral10: '#485EC4',
                        neutral60: '#ffffff',
                        neutral70: '#ffffff',
                        neutral80: '#ffffff',
                        neutral90: '#ffffff',
                        primary: '#485EC4',
                      },
                    })}
                    styles={customStyles}
                    getOptionLabel={(option) => customOptionRenderer(option)}
                  />
                </div>
                <div className={'mb-2'}>
                  <Multiselect
                    name="service_option"
                    placeholder="Select Regions"
                    ref={regionReff}
                    options={regionOptions}
                    displayValue="label"
                    closeOnSelect={true}
                    onSelect={selectRegions}
                    onRemove={removeRegions}
                    style={{
                      chips: {
                        fontSize: '10px'
                      },
                      optionContainer: {backgroundColor: "#382b42"}
                    }}/>
                </div>
                <div className={'mb-2'}>
                  <Multiselect
                    name="service_option"
                    placeholder="Select Accounts"
                    ref={accountRef}
                    options={accountOptions}
                    displayValue="label"
                    closeOnSelect={true}
                    onSelect={selectAccounts}
                    onRemove={removeAccounts}
                    style={{
                      chips: {
                        fontSize: '10px'
                      },
                      optionContainer: {backgroundColor: "#382b42"}
                    }}/>

                </div>
              </div>
            </Col>
          </Row>
          <Row className="full-width mt-4 pt-4">
            <Col lg="6" className="mt-4">
              <a href="#" onClick={(e) => {
                e.preventDefault();
                cancelMapServiceModal();
              }} className="btn btn-secondary w-md">Cancel</a>
            </Col>
            <Col lg="6" className="mt-4">
              <a href="#" onClick={(e) => {
                e.preventDefault();
                // startLoading1();
                handleServiceMapping();
              }} className="btn btn-primary w-md">Deploy Alerts</a>
            </Col>
          </Row>
        </ModalBody>

      </Modal>
    </React.Fragment>
  );
};

ServiceQuota.propTypes = {
  orders: PropTypes.array,
  onGetOrders: PropTypes.func,
  onGetServices: PropTypes.func,
};

export default withRouter(ServiceQuota);
